import { createContext } from "react";
export const ExpansionCardContext = createContext({
    open: false,
    toggleOpen: () => { },
    size: "medium",
});
//# sourceMappingURL=context.js.map